import { render, staticRenderFns } from "./CmgRewardQRModal.vue?vue&type=template&id=5161b79e&scoped=true&lang=pug&"
import script from "./cmg-reward-q-r-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-reward-q-r-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardQRModal.vue?vue&type=style&index=0&id=5161b79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161b79e",
  null
  
)

export default component.exports